// extracted by mini-css-extract-plugin
module.exports = {"container":"iq","dimension":"jq","dimensionLabels":"kq"};